(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-category-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.category-nav__item').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      var targetID = this.getAttribute('href').substring(1);
      var targetElement = document.getElementById(targetID);
      if (targetElement) {
        const targetElementTop = targetElement.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({
          top: targetElementTop,
          behavior: 'smooth'
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
